import { useEffect, useState } from 'react';
import PageMarkup from '../../common/PageMarkup';
import Analytics from './Analytics/index';
import MessageLogs from './MessageLogs/MessageLogs';
import { useLocation } from 'react-router-dom';
import { PLAN_OLD_FREE, PLAN_OLD_PRO } from '../../constants/constants';

const CommonTemplates = ({
  selectedTabForAnalytics_MessageLogs,
  showPricingBanner,
  planId,
}: any) => {
  const [selectedTab, setSelectedTab] = useState(
    selectedTabForAnalytics_MessageLogs
  );
  const location: any = useLocation();

  const tabs = [
    {
      id: 'Analytics',
      content: 'Analytics',
      accessibilityLabel: 'Analytics',
      panelID: 'Analytics',
    },
  ];

  const tabContent = {
    0: <Analytics planId={planId}></Analytics>,
  };

  if (![PLAN_OLD_FREE, PLAN_OLD_PRO].includes(Number(planId))) {
    tabs.push({
      id: 'MessageLogs',
      content: 'Message Logs',
      accessibilityLabel: 'MessageLogs',
      panelID: 'MessageLogs',
    });
    tabContent[1] = (
      <MessageLogs showPricingBanner={showPricingBanner}></MessageLogs>
    );
  }

  return (
    <>
      <PageMarkup
        title='Analytics & Logs'
        tabs={tabs}
        tabContent={tabContent}
        selected={selectedTab}
      ></PageMarkup>
    </>
  );
};
export default CommonTemplates;
